import { useDataValue, useDataChange } from 'Simple/Data.js'
import { dateISOIn, phoneNumberUS } from 'Data/format.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function getName(person) {
  return `${person.first_name} ${person.last_name}, ${
    person.gender
  }, ${dateISOIn(person.birth_date)}`
}

/** @type {(person: any) => string | null} */
export function maybeGetPhone(person) {
  let phone = person?.contact_method_associations.find(item => item.phone)
    ?.phone?.number

  return phone ? phoneNumberUS(phone) : null
}
/** @type {(person: any) => string | null} */
export function maybeGetEmail(person) {
  return (
    person?.contact_method_associations.find(item => item.email)?.email
      ?.address || null
  )
}
/** @type {(person: any) => string | null} */
export function maybeGetZip(person) {
  return (
    person?.contact_method_associations.find(item => item.postal_address)
      ?.postal_address?.zip || null
  )
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'form',
    path: 'patient',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  let patient = useDataValue({
    context: 'person',
    path: 'patient',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(patient)
    setFlowTo(normalizePath(props.viewPath, '../../../../No'))
  }
}
